/*
 * 书城
 * */
import request from "@utils/request";


/*
 * 获取书城首页数据
 * */
export function getBookHomeData() {
    return request.get("index", { type: 2}, { login: false });
}

/*
 * 书城分类
 * */
export function getBookCategory() {
    return request.get("/category", { type: 2}, { login: false });
}